module.exports = __webpack_public_path__ + "img/gb3.ef7bccbf.png";